import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-800 mt-6">This page has not been generated</h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">Tell me more about this page, so I can generate it</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          Back to Home
        </Link>
      </div>
    </div>
  );
}